import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { appname } from "../variables";

export default function Footer() {
  const location = useLocation();
  const isPath = (path) => location.pathname === path;

  return (
    <footer className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-auto pt-3 border-top border-white border-opacity-10 gap-3 flex-shrink-0">
      <div className="text-center text-md-start">
        <div className="fw-bold text-white mb-1">Indian Technology Company
        {/* <span className="status-dot-pulse ms-2"> 107A/1 Criper Road, Konnagar Hooghly, 712235, India </span> */}
        </div>
        <div className="small text-white-50">
        107A/1 Criper Road, Konnagar Hooghly, 712235, India
        </div>
       
      </div>
     
      <div className="d-flex flex-wrap justify-content-center gap-4">
        <Link to="/privacy" className={`legal-pill ${isPath('/privacy') ? 'active text-primary' : ''}`}>Privacy</Link>
        <Link to="/terms" className={`legal-pill ${isPath('/terms') ? 'active text-primary' : ''}`}>Terms</Link>
        <Link to="/mandate" className="legal-pill">Mandate</Link>
        <Link to="/refund" className="legal-pill">Refund</Link>
        <Link to="/support" className="legal-pill">Support</Link>
      </div>
      <div className="small text-white-50">
            © 2026 Indian Technology Company <span className="status-dot-pulse ms-2"></span>
      </div>
    </footer>
  );
}